import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormModal from 'components/shared/modal/FormModal';
import Button, {
  BUTTON_TYPES,
  BUTTON_COLORS,
} from 'components/shared/button/Button';
import questionMark from 'images/questionMark.svg';
import './AddProjectReportLog.css';

class ProjectReportErrorModal extends Component {
  render() {
    const { show, error, onClose, title } = this.props;
    return (
      <FormModal
        id="project-report-save-draft-modal"
        className="project-report-save-draft-modal-view"
        show={show}
        onClose={onClose}
        subTitle={title}
      >
        <div className="modal-body-section">
          <img src={questionMark} alt="Question Mark Icon" />
          <div className="text-section">{error}</div>
          <div className="buttons-section">
            <Button
              key="save-draft-button"
              type={BUTTON_TYPES.CONFIRMATION}
              color={BUTTON_COLORS.GREEN}
              label="Ok"
              onClick={onClose}
            />
          </div>
        </div>
      </FormModal>
    );
  }
}

ProjectReportErrorModal.propTypes = {
  show: PropTypes.bool,
  error: PropTypes.string,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

ProjectReportErrorModal.defaultProps = {
  show: false,
  error: '',
  title: 'Error',
  onClose: () => null,
};

export default ProjectReportErrorModal;
